import React from 'react'

import { Row, Col, Button } from '_zari/core'

import * as Sections from './sections'

const SECTIONS_IDS = {
  ADMINISTRATIVO: 'ADMIN',
  CAMBIO_FECHA_DOCUMENTOS: 'CAMBIO-FEC-DOC',
  COMPANIA_CONFIGURACION: 'COMPANIA-CONFIG',
  COMPANIA_LOGO: 'COMPANIA-LOGO'
}

const DivButton = ({ id, nombre, outline, onClick }) => {
  return (
    <Row className='mb-2'>
      <Col md={12}>
        <Button id={id} outline={outline} onClick={onClick} block>
          {nombre}
        </Button>
      </Col>
    </Row>
  )
}

const MainPage = () => {
  const [activeSection, setActiveSection] = React.useState(SECTIONS_IDS.ADMINISTRATIVO)

  return (
    <Row>
      <Col md={2}>
        <DivButton
          id={SECTIONS_IDS.ADMINISTRATIVO}
          nombre='Administrativo'
          outline={activeSection !== SECTIONS_IDS.ADMINISTRATIVO}
          onClick={() => setActiveSection(SECTIONS_IDS.ADMINISTRATIVO)}
        />
        <DivButton
          id={SECTIONS_IDS.COMPANIA_CONFIGURACION}
          nombre='Compania configuracion'
          outline={activeSection !== SECTIONS_IDS.COMPANIA_CONFIGURACION}
          onClick={() => setActiveSection(SECTIONS_IDS.COMPANIA_CONFIGURACION)}
        />
        <DivButton
          id={SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS}
          nombre='Cambio fecha documentos'
          outline={activeSection !== SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS}
          onClick={() => setActiveSection(SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS)}
        />
        <DivButton
          id={SECTIONS_IDS.COMPANIA_LOGO}
          nombre='Compania Logo'
          outline={activeSection !== SECTIONS_IDS.COMPANIA_LOGO}
          onClick={() => setActiveSection(SECTIONS_IDS.COMPANIA_LOGO)}
        />
      </Col>
      <Col md={10}>
        {activeSection === SECTIONS_IDS.ADMINISTRATIVO && <Sections.AdministrativoSection />}
        {activeSection === SECTIONS_IDS.CAMBIO_FECHA_DOCUMENTOS && <Sections.CambioFechaDocumentosSection />}
        {activeSection === SECTIONS_IDS.COMPANIA_CONFIGURACION && <Sections.CompaniaConfiguracionSection />}
        {activeSection === SECTIONS_IDS.COMPANIA_LOGO && <Sections.CompaniaLogoSection />}
      </Col>
    </Row>
  )
}

export default React.memo(MainPage)
